<script>
import { mapActions, mapGetters } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';


export default {
    props: {
        prop_edit: {
            default: true,
        }
    },
    components: {
        DatePicker,
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            single_purchase: 0,
            form: {
                id: '',
                user_id: '',
                concept_id: '',              
                date: '',
                amount: '',
                type_payment_id: '',
                description: '',
                isr_ret: '',
                iva_ret: '',
                subtotal: '',
                iva: '',
                discount: '',                
                ieps: '',
                checkbook_id: '',
                folio: '',
               
            },
            sending: false,
            file: '',
            fileName: ''
        }
    },
    methods: {
        closedModal() {
            this.form.user_id = '';
            this.form.concept_id = '';
            this.form.date = '';
            this.form.amount = '';
            this.form.type_payment_id = '';
            this.form.description = '';
            this.form.isr_ret = '';
            this.form.iva_ret = '';
            this.form.subtotal = '';
            this.form.iva = '';
            this.form.discount = '';
            this.form.ieps = '';
            this.form.checkbook_id = '';
            this.form.folio = '';
            this.sending = false;
            this.$modal.hide('addChecksBook');
            Event.$emit('event-load-FoliosCheckbooks');
        },      
        catch_file(event) {
            if (event.target.files[0].type == "application/pdf") {
                this.form.file = event.target.files[0];
                this.fileName = event.target.files[0].name;
            } else {
                this.$swal({
                    icon: 'error',
                    title: 'Error tipo de archivo',
                    text: 'Solo se puede cargar archivos PDF',
                });
            }
        },
        async saveBuildings() {
            if (this.sending) return;
            this.sending = true

            const data_form = new FormData();
            data_form.append('user_id', this.form.user_id)
            data_form.append('concept_id', this.form.concept_id)
            data_form.append('date', this.form.date)
            data_form.append('amount', this.form.amount)
            data_form.append('type_payment_id', this.form.type_payment_id)
            data_form.append('description', this.form.description)
            data_form.append('isr_ret', this.form.isr_ret)
            data_form.append('iva_ret', this.form.iva_ret)
            data_form.append('subtotal', this.form.subtotal)
            data_form.append('iva', this.form.iva)
            data_form.append('discount', this.form.discount)
            data_form.append('ieps', this.form.ieps)
            data_form.append('checkbook_id', this.form.checkbook_id)
            data_form.append('folio', this.form.folio)

            let _endpoint = '/check_checkbook';
                
            try {
                let { data } = await request.postMedia(_endpoint, data_form)
                if (data) {
                    // this.users = data.data;
                    this.successNotification(data.message);
                    this.closedModal();
                    this.sending = false;
                    Event.$emit('event-load-checks');
                }
            } catch (error) {
                this.errors = {};
                if (error.response) {
                    this.sending = false
                    this.errors = await this.errorNotification(error);
                }
            }
        },       
        calcTotal() {
            this.form.amount = this.form.subtotal + this.form.iva + this.form.ieps - this.form.isr_ret - this.form.iva_ret - this.form.discount;
        },      
        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    mounted() {
        this.catalogue.get_buildings();
        this.catalogue.get_users_profile(2);
        this.catalogue.get_concepts();
        this.catalogue.get_type_payments();      
    },
    created() {        
        Event.$on("event-show-addChecksBook", (folio, checkbook) => {
            console.log(folio);
            console.log(checkbook);
            this.form.folio = folio.folio;
            this.form.checkbook_id = checkbook.id;
            this.$modal.show('addChecksBook');
        });
    },
    computed: {
        ...mapGetters({
            'authUser': 'auth/user'
        })
    },
    watch: {      
        'form.discount'() {
            this.calcTotal();
        },
        'form.subtotal'() {
            this.calcTotal();
        },
        'form.iva'() {
            this.calcTotal();
        },
        'form.isr_ret'() {
            this.calcTotal();
        },
        'form.iva_ret'() {
            this.calcTotal();
        },
        'form.ieps'() {
            this.calcTotal();
        },
        'form.credit'() {
            this.calcTotal();
        }
    }
}
</script>

<template>

    <modal name="addChecksBook" :width="'80%'" :scrollable="true" :maxHeight="300" :height="'auto'"
        style="z-index:2000 !important">

        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()"> <i
                class="fa-solid fa-xmark"></i> </button>
        <form @submit.prevent="saveBuildings" method="post" enctype="multipart/form-data">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Información Cheque</h5>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="mt-3 col-md-6">
                        <label>Usuario</label>
                        <select type="text" :disabled="!prop_edit || single_purchase != 0" class="form-control"
                            v-model="form.user_id">
                            <option value="">Sin usuario</option>
                            <option v-for="(user, index_user) in catalogue.users_profile" :value="user.id"
                                :key="index_user">{{
                                    user.name }} {{ user.last_name }}</option>
                        </select>
                        <div v-if="errors && errors.user_id" class="text-danger">{{ errors.user_id[0] }}</div>
                    </div>
                    <div class="col-md-6 mt-3">
                        <label>Categoría</label>
                        <select type="text" :disabled="!prop_edit" class="form-control"
                            v-model="form.concept_id">
                            <option value=""> Sin categoría</option>
                            <option v-for="(concept, index_concept) in catalogue.concepts" :value="concept.id"
                                :key="index_concept">{{
                                    concept.name }}</option>
                        </select>
                        <div v-if="errors && errors.concept_id" class="text-danger">{{ errors.concept_id[0] }}</div>
                    </div>                 

                    <div class="col-md-3 mt-3">
                        <label>Subtotal</label>
                        <money :disabled="!prop_edit" class="form-control" v-model="form.subtotal"></money>
                        <div v-if="errors && errors.subtotal" class="text-danger">{{ errors.subtotal[0] }}</div>
                    </div>
                    <div class="col-md-3 mt-3">
                        <label>IVA</label>
                        <money :disabled="!prop_edit" class="form-control" v-model="form.iva"></money>
                        <div v-if="errors && errors.iva" class="text-danger">{{ errors.iva[0] }}</div>
                    </div>
                    <div class="col-md-3 mt-3">
                        <label>IEPS</label>
                        <money :disabled="!prop_edit" class="form-control" v-model="form.ieps"></money>
                        <div v-if="errors && errors.ieps" class="text-danger">{{ errors.ieps[0] }}</div>
                    </div>
                    <div class="col-md-3 mt-3">
                        <label>ISR RET</label>
                        <money :disabled="!prop_edit" class="form-control" v-model="form.isr_ret"></money>
                        <div v-if="errors && errors.isr_ret" class="text-danger">{{ errors.isr_ret[0] }}</div>
                    </div>
                    <div class="col-md-3 mt-3">
                        <label>IVA RET</label>
                        <money :disabled="!prop_edit" class="form-control" v-model="form.iva_ret"></money>
                        <div v-if="errors && errors.iva_ret" class="text-danger">{{ errors.iva_ret[0] }}</div>
                    </div>
                    <div class="col-md-3 mt-3">
                        <label>Descuento</label>
                        <money :disabled="!prop_edit" class="form-control" v-model="form.discount"></money>
                        <div v-if="errors && errors.discount" class="text-danger">{{ errors.discount[0] }}</div>
                    </div>


                    <!--  -->

                    <div class="col-md-6 mt-3">
                        <label>Total</label>
                        <money readonly :disabled="!prop_edit" class="form-control" v-model="form.amount"></money>
                        <div v-if="errors && errors.amount" class="text-danger">{{ errors.amount[0] }}</div>
                    </div>



                    <div class="col-md-6 mt-3">
                        <label>Fecha</label><br>
                        <date-picker format="YYYY-MM-DD" valueType="format" :disabled="!prop_edit" v-model="form.date"></date-picker>
                        <div v-if="errors && errors.date" class="text-danger">{{ errors.date[0] }}</div>
                    </div>

                    <div class="col-md-6 mt-3">
                        <label>Tipo de saldo</label>
                        <select type="text" :disabled="!prop_edit" class="form-control" v-model="form.type_payment_id">
                            <option value="">Sin tipo</option>
                            <option v-for="(type_payment, index_type_payment) in catalogue.type_payments"
                                :value="type_payment.id" :key="index_type_payment">{{
                                    type_payment.name }}</option>
                        </select>
                        <div v-if="errors && errors.type_payment_id" class="text-danger">{{ errors.type_payment_id[0] }}
                        </div>
                    </div>
                    <div class="col-md-12 mt-2">
                        <label>Descripción</label>
                        <textarea type="text" :disabled="!prop_edit" class="form-control"
                            v-model="form.description"></textarea>
                        <div v-if="errors && errors.description" class="text-danger">{{ errors.description[0] }}</div>
                    </div>
                    <div class="col-md-12 mt-3">
                        <label>Archivo</label><br>
                        <div class="custom-file" :style="file != '' ? 'width: 87%' : 'width: 100%'">
                            <input type="file" :disabled="!prop_edit" class="custom-file-input"
                                :class="file != '' ? 'pr-5' : ''" id="customFile" ref="file" @change="catch_file">
                            <label class="custom-file-label text-left" for="customFile">{{ fileName }}</label>
                        </div>
                        <a :href="`${globalUrlFiles}${file}`" v-if="file != ''" target="_blank"
                            style="float: right; border-radius: 5px 0px 5px 0px;" class="btn btn-info"> <i
                                class="fa-regular fa-file-pdf"></i>
                        </a>
                        <br>
                        <div v-if="errors && errors.file" class="text-danger">{{ errors.file[0] }}</div>

                    </div>

                    <div class="col-md-12">
                        <hr>
                        <button v-if="prop_edit" type="submit" :disabled="sending"
                            class="btn float-right btn-outline-success">
                            <span v-if="sending">
                                <i class="fa-solid fa-circle-notch fa-spin"></i> Procesando
                            </span>
                            <span v-else>
                                <i class="fas fa-save"></i> Guardar
                            </span>
                        </button>
                        <button type="button" @click="closedModal()" class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i>
                            Regresar
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>